type Props = {
  /** Disc diameter. `sm` (40px) sits in a drop box; `lg` (88px) on a page overlay. */
  size?: 'sm' | 'lg';
};

const SIZES: Record<'sm' | 'lg', { disc: number; glyph: number }> = {
  sm: { disc: 40, glyph: 20 },
  lg: { disc: 88, glyph: 40 },
};

/**
 * The "drop a file here" mark: an up arrow on a filled `--primary` disc. Green
 * because dropping a file starts an upload — an action (docs/design-system.md →
 * Drop Zones). The arrow is the shaft and chevron of the quick-actions
 * `UploadIcon` without its tray, so the two read as one family.
 */
const DropUploadIcon = ({ size = 'sm' }: Props) => {
  const { disc, glyph } = SIZES[size];
  return (
    <svg
      width={disc}
      height={disc}
      viewBox={`0 0 ${disc} ${disc}`}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx={disc / 2} cy={disc / 2} r={disc / 2} fill="var(--primary)" />
      <svg
        x={(disc - glyph) / 2}
        y={(disc - glyph) / 2}
        width={glyph}
        height={glyph}
        viewBox="0 0 24 24"
        fill="none"
        stroke="var(--background)"
        strokeWidth={size === 'lg' ? 2.4 : 2.2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="17 9 12 4 7 9" />
        <line x1="12" y1="4" x2="12" y2="19" />
      </svg>
    </svg>
  );
};

export default DropUploadIcon;
